/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Erp_Item_FileInputs */

const en_reference_field_erp_item_file = /** @type {(inputs: Reference_Field_Erp_Item_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gets the file of the items to the ERP`)
};

/**
* | output |
* | --- |
* | "Gets the file of the items to the ERP" |
*
* @param {Reference_Field_Erp_Item_FileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_erp_item_file = /** @type {((inputs?: Reference_Field_Erp_Item_FileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Erp_Item_FileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_erp_item_file(inputs)
});